import { theme } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { useIntl } from 'react-intl'

import { FaqAccordion, FaqItem } from 'components/molecules/faqAccordion'
import { useIsMobile } from 'hooks/useIsMobile'
import { assetImagePath } from 'interfaces/constants'
import { Trimester } from 'interfaces/types/DueDate'
import { useMemo } from 'react'

type Props = {
  currentFaqs?: Trimester[]
  bgContentColor?: string
}

const dataEventLabelFn = (faq: FaqItem) => faq.rawTitle || ''

const CurrentDueDateFaqs = ({
  currentFaqs,
  bgContentColor = theme.colors.gray50,
}: Props) => {
  const isMobile = useIsMobile()
  const { formatMessage: f } = useIntl()

  const formattedFaqs = useMemo(() => {
    return (
      currentFaqs?.map((faq) => ({
        rawTitle: faq.title,
        title: (
          <Text size="p2" weight="semiBold" color={theme.colors.gray800}>
            {faq.title}
          </Text>
        ),
        description: faq.content,
      })) || []
    )
  }, [currentFaqs])

  if (!currentFaqs) return null

  return (
    <FaqAccordion
      dataEventCategory="Health Tool"
      dataEventAction="Due Date - FAQ"
      dataEventLabel={dataEventLabelFn}
      faqs={formattedFaqs}
      titleProps={{
        icon: (
          <img
            style={{
              height: '18px',
              width: '18px',
            }}
            src={`${assetImagePath}/info-icon.svg`}
            alt=""
            loading="lazy"
          />
        ),
        headingTitle: (
          <Text
            size={isMobile ? 'c1' : 'c2'}
            weight="semiBold"
            color={theme.colors.gray600}
            transform="uppercase"
            span
          >
            {f({ id: 'dueDatePage.faqs' })}
          </Text>
        ),
      }}
      template="due-date"
      bgContentColor={bgContentColor}
    />
  )
}

export default CurrentDueDateFaqs
